const { analyticsEventBus, ANALYTICS_EVENTS } = require('../../events');
const { createCustomEventGA4 } = require('../models/customEventGA4');
const pushEvent = require('../pushEvent');

/* -------------------------------------------------------------------------- *\
 * TOP BANNER EVENTS                                                          *
\* -------------------------------------------------------------------------- */

/**
 * Subscribe to our analytics events and push to dataLayers
 */
function subscribeToAnalyticsEvents() {
  analyticsEventBus.subscribe(ANALYTICS_EVENTS.topBannerClicked, (payload) => {
    pushEvent(
      createCustomEventGA4('top_banner', [
        ['action', 'click'],
        ['item', payload.item],
      ])
    );
  });
}

module.exports = {
  subscribeToAnalyticsEvents,
};
